import {DrawerProps} from '@mantine/core';
import {I18n} from '@aws-amplify/core';
import {RecordForm} from "../forms/RecordForm.tsx";
import {ProductFeature} from "../types.ts";
import {PlatformDrawer} from '@flexinet/ui-components';

export const FormDrawer = (
    {
        record,
        handleSubmit,
        opened,
        onClose,
        ...rest
    }: DrawerProps & {
        record: ProductFeature,
        // Resolves true when the record was saved. The drawer closes ONLY then: a server
        // error leaves it open with the operator's values.
        handleSubmit: (values: ProductFeature) => Promise<boolean>
    }) => {

    const title = record?.id ? I18n.get('Edit Product Feature') : I18n.get('Add Product Feature');

    const handleFormSubmit = async (values: ProductFeature) => {
        const saved = await handleSubmit(values);
        if (saved) {
            onClose();
        }
    };

    return (
        <PlatformDrawer
            opened={opened}
            onClose={onClose}
            title={title}
            {...rest}
        >
            <RecordForm
                record={record}
                handleSubmit={handleFormSubmit}
                handleCancel={onClose}
            />
        </PlatformDrawer>
    )
};
